<template>
  
        <div class="col-30">
            <aside class="blog__sidebar">
                <div class="sidebar__widget sidebar__widget-two">
                                        <div class="sidebar__search">
                                            <form @submit.prevent>
                                                <input type="text" placeholder="Cari Berita . . ." name="search" id="wid-search" value="" v-model="cari_value" @keyup="cari_data()" @keyup.enter.prevent="cari_data">
                                                <button type="submit">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                                        <path d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </button>
                                            </form>
                                        </div>
                                    </div>
 
 
                <div class="sidebar__widget">
                    <h4 class="sidebar__widget-title">Postingan Terbaru</h4>
 
                    <div class="sidebar__post-list" v-for="(item, index) in listBerita" :key="index">
                        <div class="sidebar__post-item" :key="index">
                            <div class="sidebar__post-thumb">
                                <a href="blog-details.html"><img :src="$store.state.UPLOADS+item.foto" alt="Apexa" /></a>
                            </div>
                            <div class="sidebar__post-content">
                                <h5 class="title" style="font-size: 14px;"><a href="blog-details.html">{{item.judul}}</a></h5>
                                <span class="date"><i class="flaticon-time"></i>{{UMUM.tglConvert(item.createAt).tgl}}</span>
                            </div>
                        </div>
 
                    </div>
                </div>

 

            </aside>
        </div>
 
</template>

<script>
import UMUM from "../library/umum";
export default {

    data() {
        return {
            UMUM:UMUM,
            listBerita:[],
        }
    },    
    methods: {

        fetchBerita() { 
            fetch(this.$store.state.BASE_URL + 'api/v1/web_publish_berita/homeOPD/', {
                method: "GET",
                headers: {
                "content-type": "application/json", 
                }, 
            })
            .then(res => res.json())
            .then(res_data => { 
                this.listBerita = res_data;
            });     
        },

    },
    mounted() {
        this.fetchBerita()
        
    },

}
</script>